/**
 * Eyebrow navigation — social dropdown (desktop bar + mobile drawer).
 */
(function () {
  function wireSocialDropdown(nav) {
    const btn = nav.querySelector('[data-ez-eyebrow-social-toggle]');
    const panel = nav.querySelector('.ez-eyebrow-nav__social-panel');
    if (!btn || !panel || btn.dataset.ezSocialWired === 'true') return;

    btn.dataset.ezSocialWired = 'true';

    if (!panel.id) {
      panel.id = 'ez-eyebrow-social-' + Math.random().toString(36).slice(2, 9);
    }
    btn.setAttribute('aria-controls', panel.id);

    let onDocumentClick = null;

    function close() {
      btn.setAttribute('aria-expanded', 'false');
      panel.hidden = true;
      if (onDocumentClick) {
        document.removeEventListener('click', onDocumentClick);
        onDocumentClick = null;
      }
    }

    function open() {
      btn.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      if (onDocumentClick) return;

      onDocumentClick = (event) => {
        if (nav.contains(event.target)) return;
        close();
      };

      // Defer so this click doesn't immediately close the panel we just opened.
      window.setTimeout(() => {
        document.addEventListener('click', onDocumentClick);
      }, 0);
    }

    btn.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      if (btn.getAttribute('aria-expanded') === 'true') {
        close();
      } else {
        open();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') {
        close();
      }
    });
  }

  function mountDrawerEyebrow() {
    const source = document.querySelector('[data-ez-eyebrow-drawer-source]');
    const slot = document.querySelector('[data-ez-eyebrow-drawer-slot]');
    if (!source || !slot) return;

    const clone = source.cloneNode(true);
    clone.hidden = false;
    clone.removeAttribute('data-ez-eyebrow-drawer-source');
    slot.replaceChildren(clone);

    const nav = clone.querySelector('.ez-eyebrow-nav');
    if (nav) {
      const btn = nav.querySelector('[data-ez-eyebrow-social-toggle]');
      if (btn) delete btn.dataset.ezSocialWired;
      wireSocialDropdown(nav);
    }
  }

  function init() {
    mountDrawerEyebrow();
    document.querySelectorAll('.ez-eyebrow-nav').forEach((nav) => {
      if (nav.closest('[data-ez-eyebrow-drawer-source]')) return;
      wireSocialDropdown(nav);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
